export default __webpack_public_path__ + "static/media/14.17535c89.png";